import { createAppSlice } from "Data/Redux/Store";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { CodecSettingsState } from "Interfaces";
import { DUMMY_CODEC_SETTINGS } from "Data/Dummy/Camera";

export const setCodecReducer = (state: CodecSettingsState, action: PayloadAction<CodecSettingsState>) => {
	return action.payload;
};

export const getCodec = (state: CodecSettingsState) => {
	return state;
};

export const getStreams = (state: CodecSettingsState) => {
	return state?.streams ?? [];
};

const codecSlice = createAppSlice({
	name: "codec",
	initialState: DUMMY_CODEC_SETTINGS,
	reducers: {
		setCodecAction: setCodecReducer
	},
	selectors: {
		selectCodec: getCodec,
		selectStreams: getStreams
	}
});

export default codecSlice;

export const { setCodecAction } = codecSlice.actions;
export const { selectCodec, selectStreams } = codecSlice.selectors;
